/* BlackBole Studio — motion for .bbs sections. No dependencies. */
(function(){
  if(window.__bbsInit)return;window.__bbsInit=true;
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s,r){return (r||document).querySelector(s)}
  function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}

  function hero(h){
    if(h._bbs)return;h._bbs=1;
    var slides=$$('.bbs-slide',h),bars=$$('.bbs-hero__bars button',h),DUR=5500,i=0,t=null;
    if(slides.length<2)return;
    h.style.setProperty('--dur',DUR+'ms');
    function restart(){clearTimeout(t);if(!reduce&&!h.classList.contains('paused'))t=setTimeout(function(){go(i+1)},DUR)}
    function go(n){i=(n+slides.length)%slides.length;slides.forEach(function(s,k){s.classList.toggle('on',k===i)});bars.forEach(function(b,k){b.classList.remove('on');void b.offsetWidth;b.classList.toggle('on',k===i)});restart()}
    bars.forEach(function(b,k){b.onclick=function(){go(k)}});
    var p=$('[data-prev]',h),nx=$('[data-next]',h);if(p)p.onclick=function(){go(i-1)};if(nx)nx.onclick=function(){go(i+1)};
    h.addEventListener('mouseenter',function(){h.classList.add('paused');clearTimeout(t)});
    h.addEventListener('mouseleave',function(){h.classList.remove('paused');restart()});
    var sx=null;h.addEventListener('touchstart',function(e){sx=e.touches[0].clientX},{passive:true});
    h.addEventListener('touchend',function(e){if(sx==null)return;var dx=e.changedTouches[0].clientX-sx;sx=null;if(Math.abs(dx)>40)go(i+(dx<0?1:-1))});
    document.addEventListener('visibilitychange',function(){document.hidden?clearTimeout(t):restart()});
    go(0);
  }

  function rail(el){
    if(el._bbs)return;el._bbs=1;
    var wrap=el.closest('.bbs-rail-wrap'),prog=$('.bbs-progress i',wrap),prev=$('[data-rail-prev]',wrap),next=$('[data-rail-next]',wrap);
    function upd(){var max=el.scrollWidth-el.clientWidth;var vis=el.clientWidth/Math.max(el.scrollWidth,1);prog.style.width=(vis*100)+'%';prog.style.transform='translateX('+(max>0?(el.scrollLeft/max)*((1/vis)-1)*100:0)+'%)';prev.disabled=el.scrollLeft<4;next.disabled=el.scrollLeft>max-4}
    function step(){var c=el.firstElementChild;return c?c.getBoundingClientRect().width+parseFloat(getComputedStyle(el).columnGap||16):300}
    prev.onclick=function(){el.scrollBy({left:-step()*2})};next.onclick=function(){el.scrollBy({left:step()*2})};
    el.addEventListener('scroll',upd,{passive:true});addEventListener('resize',upd);upd();
    var down=false,x0=0,s0=0,moved=0;
    el.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse')return;down=true;moved=0;x0=e.clientX;s0=el.scrollLeft});
    addEventListener('pointermove',function(e){if(!down)return;var dx=e.clientX-x0;moved=Math.max(moved,Math.abs(dx));if(moved>5)el.classList.add('dragging');el.scrollLeft=s0-dx});
    addEventListener('pointerup',function(){if(!down)return;down=false;setTimeout(function(){el.classList.remove('dragging')},0)});
    el.addEventListener('dragstart',function(e){e.preventDefault()});
    el._upd=upd;
  }

  function tabs(t){
    if(t._bbs)return;t._bbs=1;
    var btns=$$('button',t),pill=$('.bbs-tabs__pill',t),panels=$$('[data-tab-panel="'+t.dataset.bbsTabs+'"]');
    function place(b){if(!b)return;pill.style.width=b.offsetWidth+'px';pill.style.transform='translateX('+(b.offsetLeft-4)+'px)'}
    function cur(){return btns.filter(function(b){return b.getAttribute('aria-selected')==='true'})[0]}
    btns.forEach(function(b){b.onclick=function(){
      btns.forEach(function(x){x.setAttribute('aria-selected',x===b)});place(b);
      panels.forEach(function(p){var on=p.dataset.tab===b.dataset.tab;p.hidden=!on;if(on){var r=$('.bbs-rail',p);if(r){r.scrollLeft=0;r.classList.remove('bbs-rail-fade');void r.offsetWidth;r.classList.add('bbs-rail-fade');r._upd&&r._upd()}}});
    }});
    requestAnimationFrame(function(){place(cur())});addEventListener('resize',function(){place(cur())});
  }

  function buybar(){
    if(!document.body.matches('[data-bbs-product]')&&!document.querySelector('main[data-template^="product"]'))return;
    if($('.bbs-buybar'))return;
    var form=$('main form[action*="/cart/add"]')||$('main .product-form')||$('main product-form-component');
    var title=$('main h1');if(!form||!title)return;
    var priceEl=$('main product-price')||$('main .price');
    var bar=document.createElement('div');bar.className='bbs-buybar';bar.setAttribute('role','region');bar.setAttribute('aria-label','Quick order');
    bar.innerHTML='<div class="bbs-buybar__t"><b></b><span></span></div><button type="button" class="bbs-btn bbs-btn--black">Order now</button>';
    $('b',bar).textContent=title.textContent.trim();
    function sp(){var t=priceEl?priceEl.textContent.replace(/\s+/g,' ').trim():'';var m=t.match(/(?:৳|Tk|BDT)\s?[\d,]+(?:\.\d+)?|[\d,]+(?:\.\d+)?\s?(?:৳|Tk|BDT)/);$('span',bar).textContent=m?m[0]:''}
    sp();
    $('button',bar).onclick=function(){form.scrollIntoView({behavior:reduce?'auto':'smooth',block:'center'})};
    document.body.appendChild(bar);
    var wa=document.getElementById('bbWhatsappFloat');
    function chk(){var on=form.getBoundingClientRect().bottom<0;bar.classList.toggle('show',on);if(wa&&innerWidth<990)wa.style.bottom=on?'84px':''}
    addEventListener('scroll',chk,{passive:true});addEventListener('resize',chk);chk();
  }

  function init(root){
    $$('[data-bbs-hero]',root).forEach(hero);
    $$('.bbs-rail',root).forEach(rail);
    $$('[data-bbs-tabs]',root).forEach(tabs);
  }
  function boot(){init(document);buybar()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
